import {useId, ReactNode} from 'react';
import classNames from 'classnames';

import {Radio} from '@udemy-v2/react-form-components';
import styles from './collapsible-purchase-section.module.scss';

export interface CollapsiblePurchaseSectionProps {
    title: ReactNode;
    children: ReactNode;
    expanded?: boolean;
    showRadio?: boolean;
    onExpand?: () => void;
}

export const CollapsiblePurchaseSection = ({
    title,
    children,
    expanded = false,
    showRadio = true,
    onExpand,
}: CollapsiblePurchaseSectionProps) => {
    const contentId = useId();

    const handleClick = () => {
        if (!expanded) {
            onExpand?.();
        }
    };

    return (
        <div className={styles['panel']}>
            <button
                type="button"
                aria-expanded={expanded}
                aria-controls={contentId}
                onClick={handleClick}
                className={styles['panel-toggler']}
            >
                <div className={styles['radio-controlled-title-wrapper']}>
                    {showRadio && (
                        <div className={styles['radio']}>
                            <Radio size={'large'} checked={expanded} readOnly={true} />
                        </div>
                    )}
                    <div className={styles['radio-controlled-title']}>{title}</div>
                </div>
            </button>
            <div
                id={contentId}
                role="group"
                aria-hidden={!expanded}
                className={classNames({[styles['panel-content-collapsed']]: !expanded})}
            >
                <div className={styles['radio-controlled-content']}>{children}</div>
            </div>
        </div>
    );
};
